// PDF by email instead of browser printing. With a lead endpoint configured, the report's print
// stylesheet shows only a notice (.print-gate) and Ctrl/Cmd+P jumps to the PDF form; the PDF itself is
// rendered by lead-worker (Browser Rendering), which sets window.__SONCNIK_PDF to lift the gate.

/**
 * Set by the PDF renderer before any script runs: `to` is the recipient (printed in the footer), `name` / `address`
 * the optional investor for subsidy and loan applications (printed in the document header, never stored).
 */
export const pdfMode: { to?: string; name?: string; address?: string } | null = typeof window !== 'undefined' ? (window as any).__SONCNIK_PDF ?? null : null;

export const PDF_FORM_ID = 'poslji-pdf';

export function goToPdfForm() {
  const box = document.getElementById(PDF_FORM_ID);
  if (!box) return;
  box.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
  box.querySelector<HTMLInputElement>('input[type=email]')?.focus({ preventScroll: true });
}
